import { apiInitialState } from '../../../utils/reduxOperations';

export default {
    sentimentApi: apiInitialState(),
    batchIdsApi:apiInitialState(),
    filtersApi:apiInitialState(),
    activeFacet:''
};